import { applyMiddleware, createStore } from 'redux'
import { createRootReducer } from './rootReducer.js'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'

const composeEnhancers = composeWithDevTools({
  trace: true,
})

const enhancer = composeEnhancers(applyMiddleware(thunk))

export default function generateNewStore() {
  return createStore(createRootReducer(), enhancer)
}
